const common = {
    'common.sure': 'OK',
    'common.save': 'Salvar',
    'common.cancel': 'Cancelar',
    'common.loading': 'Carregando...',
    'common.loading.noMore': 'sem mais',
    'common.loading.loading1': 'Carregando',
    'common.success': 'sucesso',
    'common.fail': 'Falha',
    'common.unKnowError': 'Exceção desconhecida',
    'common.unitDayOdd': 'dia',
    'common.unitDayPlural': 'dias',
    'common.unitMonthOdd': 'mês',
    'common.unitMonthPlural': 'meses',
    'common.infiniteAct': '1º ilimitado !',
    'common.label': 'Promoção a chegar',
    'common.404': 'Opa. A página que você requisitou não foi encontrada!'
}
const language = {
    'lang.chinese': 'Chinês',
    'lang.english': 'Inglês',
    'lang.germany': 'Alemão',
    'lang.spanish': 'Espanhol',
    'lang.french': 'Francês',
    'lang.italian': 'Italiano',
    'lang.portuguese': 'português',
}
// 登录页
const login = {
    'login.loginText': 'Iniciar sessão',
    'login.input.email': 'Endereço de e-mail (LenovoID)',
    'login.input.password': 'Senha',
    'login.tip.noAccount': 'Ainda não possui conta?',
    'login.tip.toRegister': 'Vá para Inscrever-se.',
    'login.tip.forget': 'Esquecer a senha?',
    'login.check.noInfo': 'Senha ou e-mail incorretos.',
    'login.failed': 'Falha ao iniciar sessão',
    'login.terms': 'Por favor, reveja os termos e condições',
    'login.banner.flow': 'Registre-se agora e desfrute de dados gratuitos de 1GB*6 meses',
    'login.banner.VFflow': 'Registre-se agora e desfrute de dados gratuitos de 5GB*3 meses',
    'login.banner.coming': 'Promoção a chegar:',
    'login.banner.size': 'primeiro mês explode dados ilimitados'
}
// 注册页面
const register = {
    'register.registerText': 'Inscrever-se',
    'register.input.firstName': 'Primeiro Nome',
    'register.check.noFirstNameField': 'Insira o Primeiro Nome',
    'register.input.lastName': 'Apelido',
    'register.check.noLastNameField': 'Insira o Apelido',
    'register.input.email': 'E-mail',
    'register.input.imgCode': 'Captcha de imagem',
    'register.input.verifyCode': 'Captcha',
    'register.input.password': 'Senha',
    'register.input.rePassword': 'Confirmar senha',
    'register.input.alRegister': 'Já registrado',
    'register.input.toLogin': 'Vá para Iniciar Sessão',
    'register.input.termsOfService': 'Termos de Uso',
    'register.input.privacyStatement': 'Declaração de Privacidade',
    'register.tip': 'Ao criar uma conta, você concorda com os {termsOfService} e {privacyStatement}.',
    'register.tipForTablet': 'Ao criar a conta, você leu e aceitou as <a1>Descrições do Plano de Dados de Pré-carga</a1>, <a2>Termos e Condições</a2> da Lenovo Connect, <a3>Termos e Condições</a3> da HUE, <a4>Política de Privacidade</a4> da Lenovo Connect e <a5>Política de Privacidade</a5> da HUE.',
    'register.sendMsg.text': 'Obtenha o captcha',
    'register.sendMsg.reSend': 'Reenviar',
    'register.sendMsg.sendSuccess': 'Enviado com êxito',
    'register.sendMsg.sendFailed': 'Falha ao enviar',
    'register.check.noEmailField': 'Insira o e-mail',
    'register.check.noImageCodeField': 'Insira o captcha de imagem',
    'register.check.noVerifyField': 'Insira o captcha que você obteve',
    'register.check.noPasswdField': 'Insira a senha',
    'register.check.noConfirmPasswd': 'Confirme a senha',
    'register.check.errorEmail': 'A entrada não é um e-mail válido',
    'register.check.errorVerifyCode': 'Captcha incorreto',
    'register.check.errorImageCode': 'Captcha de imagem incorreta',
    'register.check.errorPasswd': 'Senha incorreta',
    'register.check.errorTwoPasswd': 'As duas senhas que você inseriu não coincidem',
    'register.success': 'Inscrição realizada com êxito',
}
// 首页
const home = {
    'home.header.upload': 'Carregamento',
    'home.header.iccid': 'Código ICCID',
    'home.flowUse.title': 'Minha Permissão de Dados Atual',
    'home.flowUse.status.title': 'Status de Uso',
    'home.flowUse.status.used': 'Usei este ciclo',
    'home.flowUse.status.remaining': 'Restante',
    'home.flowUse.dataPlan.key': 'Nome do Plano de Dados',
    'home.flowUse.validity.key': 'Validade',
    'home.flowUse.note.key': 'Observação',
    'home.flowUse.note': 'Assim que a permissão de dados for atingida no ciclo atual, a conectividade será interrompida até o próximo ciclo.',
    'home.flowUse.leftDay': '{day} {unit} restante(s)',
    'home.flowUse.currentDataPlan.title': 'Meu(s) Plano(s) de Dados',
    'home.flowUse.currentDataPlan.titleHue': 'Meu pacote de serviço de conectividade',
    'home.flowUse.outDate': 'O plano de dados expirou',
    'home.flowUse.lock': 'O cartão SIM está bloqueado',
    'home.flowUse.noDataPlan': 'Nenhum plano de dados usado ainda',
    'home.flowUse.status.unlimited': 'Ilimitado',
    'home.area.intro.title': 'Completar',
    'home.area.intro.titleHue': 'Completar',
    'home.area.intro.content': 'Nossos planos podem cobrir todos os <cta>países da UE</cta> (Áustria, Bélgica, Bulgária, Croácia, Chipre, República Tcheca, Dinamarca, Estônia, Finlândia, França, Alemanha, Gibraltar, Grécia, Hungria, Irlanda, Itália, Letônia, Lituânia, Luxemburgo, Malta, Holanda, Polônia, Portugal, Romênia, República Eslovaca, Eslovênia, Espanha, Suécia), <cta>.',
    'home.area.intro.contentHUE': 'Nossos planos podem cobrir todos os <cta>países da UE</cta> (Áustria, Bélgica, Bulgária, Croácia, Chipre, República Tcheca, Dinamarca, Estônia, Finlândia, França, Alemanha, Gibraltar, Grécia, Hungria, Irlanda, Itália, Letônia, Lituânia, Luxemburgo, Malta, Holanda, Polônia, Portugal, Romênia, República Eslovaca, Eslovênia, Espanha, Suécia), <cta>mais Islândia, Noruega, Suíça, Reino Unido,</cta>Ative o Mobile Data&Roaming (sem taxa extra de roaming).',
    'home.area.intro.vatIntro': 'Os preços incluem IVA, se aplicável',
    'home.area.intro.suggest': 'Sugerir',
    'home.area.switch.title': 'Região:',
    'home.active.title': 'Ativar meu Plano de Dados de Pré-carga',
    'home.active.intro': 'O plano de dados de pré-carga "{packageContent}" deve ser ativado dentro de 90 dias após ligar o dispositivo. A validade de {timeLength} segue imediatamente a ativação.',
    'home.active.agree': 'Ao ativá-lo, você concorda com a <a>Descrição do Plano de Dados de Pré-carga</a>, os <a1>Termos e Condições</a1> e a <a2>Política de Privacidade.</a2> Lenovo Connect Powered by Truphone.',
    'home.active.agreeForTablet': 'Ao ativá-lo, você concorda com a <a>Descrição do Plano de Dados de Pré-carga</a>, os <a1>Termos e Condições</a1> e a <a2>Política de Privacidade.</a2>',
    'home.active.btnText': 'Ativo agora',
    'home.active.failed': 'Falha ao ativar !',
    'home.active.success': 'Ativado com êxito',
    'home.active.success.btn': 'OK',
    'home.active.detail.title': 'Descrição do plano de dados de pré-carga',
    'home.active.detail.faq': 'Caso tenha alguma dúvida, verifique <a>Atendimento ao Cliente</a>',
}
const suggest = {
    'suggest.title': 'Caixa de sugestões',
    'suggest.toast': 'Por favor, insira o conteúdo',
    'suggest.success': 'Bem-sucedido',
    'suggest.suggestions': 'Por favor, compartilhe suas sugestões ou dúvidas conosco',
    'suggest.submit': 'Enviar',
    'suggest.information': 'Em formação',
    'suggest.submission': 'Meu envio',
    'suggest.noMore': 'Sem mais dados',
    'suggest.uploadImg': "O tamanho da imagem não deve exceder 5M",
}
const me = {
    'me.signOut': 'Sair',
    'me.nav.device': 'Dispositivo',
    'me.nav.package': 'Plano(s) de Dados',
    'me.nav.order': 'Pedido',
    'me.nav.accountInfo': 'Informações da Conta',
    'me.nav.FAQ': 'Perguntas frequentes',
    'me.nav.contactUs': 'Entre em contato connosco',
    'me.signOut.alert.title': 'Sair',
    'me.signOut.alert.content': 'Deseja mesmo sair?'
}
// 账号信息
const accountInfo = {
    'account.errorNickname': 'O comprimento da alcunha deve ser de 4 a 20 caracteres.',
    'account.account.fieldTitle': 'Conta',
    'account.nickName.fieldTitle': 'Alcunha',
    'account.nickName.character': '4–20 caracteres incluindo letras, dígitos e "-"',
}
// 套餐卡片
const packageCard = {
    'package.validDate': '{timeLength} {dateUnit} válido',
    'package.validTo': 'válido até {data} UTC',
    'package.orderBtnText': 'Fazer o Pedido Agora',
    'package.extend.title': 'Estender Meu Plano de Dados',
    'package.expand.title': 'Expandir Meu Plano de Dados',
    'package.extend.titleHue': 'Assine um pacote mensal de serviços de conectividade',
    'package.expand.titleHue': 'Adicione um pacote de serviço de conectividade extra',
    'package.expand.add': 'Adicionar',
}
// 套餐详情
const packageDetail = {
    'packageDetail.privacy': 'Sim, li e aceitei os <a>Termos e Condições</a> e a <b>Política de Privacidade</b>. ',
    'packageDetail.privacyForTablet': 'Sim, li e aceitei os <a>Termos e Condições</a> e a <b>Política de Privacidade</b>. ',
    'packageDetail.description': 'Descrição',
    'packageDetail.expansionPackage.title': 'Expandir o Ciclo Atual',
    'packageDetail.payBtn.text': 'Pagar agora',
}
// 地址
const billAddress = {
    'billAddress.history.title': 'Endereço de facturamento histórico',
    'billAddress.fieldWrap.title': 'Insira o Seu Endereço de Faturação',
    'billAddress.btn.continue': 'Prosseguir',
    'billAddress.btn.cancel': 'Cancelar',
    'billAddress.field.firstName': 'Primeiro Nome',
    'billAddress.field.lastName': 'Apelido',
    'billAddress.field.email': 'E-mail',
    'billAddress.field.street': 'Rua',
    'billAddress.field.city': 'Cidade',
    'billAddress.tips.payment': 'como pagar',
    'billAddress.tips.newCard': 'novo cartão',
    'billAddress.tips.oldCard': 'cartão antigo',
    'billAddress.field.state': 'Estado',
    'billAddress.field.postCode': 'Código postal',
    'billAddress.field.country': 'País',
    'billAddress.field.firstNameError': 'Primeiro Nome é um campo obrigatório',
    'billAddress.field.lastNameError': 'Apelido é um campo obrigatório',
    'billAddress.field.emailError': 'E-mail é um campo obrigatório',
    'billAddress.field.emailFormatError': 'Insira um e-mail válido',
    'billAddress.field.streetError': 'Rua é um campo obrigatório',
    'billAddress.field.cityError': 'Cidade é um campo obrigatório',
    'billAddress.field.stateError': 'Estado é um campo obrigatório',
    'billAddress.field.postCodeError': 'Código Postal é um campo obrigatório',
    'billAddress.field.countryError': 'País é um campo obrigatório',
}
// 订单
const order = {
    'order.subType.1': 'Pré-carga',
    'order.subType.2': 'Recarga',
    'order.subType.4': 'troca',
    'order.subType.5': 'presente',
    'order.subType.6': 'Pedido corporativo',
    'order.subType.7': 'Pacote de experiência',
    'order.subType.8': 'atualização',
    'order.subType.9': 'Reabastecimento',
    'order.subType.systemOrder': 'Pedido do sistema',
    'order.item.orderNum': 'Número do Pedido',
    'order.item.content': 'Conteúdo',
    'order.item.orderType': 'Tipo de Pedido',
    'order.item.validity': 'Validade',
    'order.item.subTotal': 'Subtotal',
    'order.item.vat': 'VAT',
    'order.item.totalFee': 'Total',
    'order.noInfo.message': 'Você ainda não encomendou nenhum plano.!',
    'order.noInfo.btnText': 'Ir para o início'
}

// 支付结果页
const payResult = {
    'pay.success': 'Pagamento bem-sucedido',
    'pay.fail': 'Falha no pagamento',
    'pay.checkOrder': 'Verificar pedido',
    'pay.back': 'Voltar',
    'pay.continue': 'Continuar a pedir',
}

// 我的设备页面
const device = {
    'device.switch': 'Alterar de dispositivo',
    'device.status.current': 'Atual',
    'device.status.available': 'Disponível',
    'device.switch.alert.title': 'Mensagem',
    'device.switch.alert.content': 'Confirma a mudança para este dispositivo?',
    'device.noInfo.message': 'Você não vinculou nenhum dispositivo ainda.',
    'device.noInfo.btnText': 'Carregar Código ICCID',
    'device.edit.prompt.message': 'Insira sua alcunha',
    'device.edit.check.none': 'Alcunha é um campo obrigatório'
}

// 我的套餐
const myDataPlan = {
    'myDataPlan.tabbar.available': 'Plano(s) de Dados Disponível(eis)',
    'myDataPlan.tabbar.expired': 'Plano(s) de Dados Expirado(s)',
    'myDataPlan.noAvailablePlan': 'Nenhum plano disponível no momento',
    'myDataPlan.noExpiredPlan': 'Nenhum plano expirado no momento',
}
// 联系我们
const Contact = {
    'contact.chooseRegion.text': 'Escolha sua região',
    'contact.country.AT': 'Áustria',
    'contact.country.BE': 'Bélgica',
    'contact.country.DK': 'Dinamarca',
    'contact.country.FI': 'Finlândia',
    'contact.country.FR': 'França',
    'contact.country.DE': 'Alemanha',
    'contact.country.IE': 'Irlanda',
    'contact.country.IT': 'Itália',
    'contact.country.LUX': 'Luxemburgo',
    'contact.country.NL': 'Holanda',
    'contact.country.NO': 'Noruega',
    'contact.country.PT': 'Portugal',
    'contact.country.ES': 'Espanha',
    'contact.country.SE': 'Suécia',
    'contact.country.CH': 'Suíça',
    'contact.country.UK': 'Reino Unido',
    'contact.country.USA': 'EUA',

    'contact.contactus.PT': 'Entre em contato com service@lenovoconnect.com para obter detalhes do pedido e atendimento ao cliente.',

    'contact.phone.AT': '(+43) (0)1 9287 666',
    'contact.phone.BE': '02-700-73-77 (lokaal tarief)',
    'contact.phone.DK': '+45 89881536',
    'contact.phone.FI': '+358 97 47 90 251',
    'contact.phone.FR': '+ 33 170 381 927',
    'contact.phone.DE': '(+49) (0)201 22099 888',
    'contact.phone.IE': '1-890-928-860 (As chamadas para este número são cobradas na tarifa local a partir de um telefone fixo e têm um custo mínimo de € 0,05. As chamadas de telemóveis podem variar.)',
    'contact.phone.IT': '(+39)02 303 10000',
    'contact.phone.LUX': '+352 2487 16 11',
    'contact.phone.NL': '+31 204 990 153',
    'contact.phone.NO': '+47 67 204501',
    'contact.phone.PT': '+351 211 227 833',
    'contact.phone.ES': '+34 9179 11 799',
    'contact.phone.SE': '+46 840 30 01 81',
    'contact.phone.CH': '+41 44 798 2222',
    'contact.phone.UK': '+44 333-777-3991 (Taxa Nacional)',
    'contact.phone.USA': '1-800-426-7378, # 1',

    'contact.workHours.AT': '9:00 - 18:00 de segunda a sexta',
    'contact.workHours.BE': '9:00 - 18:00 de segunda a sexta',
    'contact.workHours.DK': '9:00 - 18:00 de segunda a sexta',
    'contact.workHours.FI': '9:00 - 18:00 de segunda a sexta',
    'contact.workHours.FR': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.DE': '8-18 Uhr Montag - Freitag',
    'contact.workHours.IE': '9:00 - 18:00 de segunda a sexta',
    'contact.workHours.IT': '9:00 - 18:00 de segunda a sexta',
    'contact.workHours.LUX': '9:00 - 18:00 de segunda a sexta',
    'contact.workHours.NL': '9:00 - 18:00 de segunda a sexta',
    'contact.workHours.NO': '9:00 - 18:00 de segunda a sexta',
    'contact.workHours.PT': '9:00 - 18:00 de segunda a sexta',
    'contact.workHours.ES': 'de 8:00h a 18:00h, de lunes a viernes',
    'contact.workHours.SE': '9:00 - 18:00 de segunda a sexta',
    'contact.workHours.CH': '9:00 - 18:00 de segunda a sexta',
    'contact.workHours.UK': '9:00 - 18:00 de segunda a sexta',
    'contact.workHours.USA': '00:00 - 24:00 de segunda a domingo',
}
// 绑卡页面
const bindSim = {
    'bindSim.hello': 'Olá',
    'bindSim.activate.title': 'Ativar Seu Plano de Dados',
    'bindSim.tip.text1': 'Carregue a imagem do código de barras para vincular o cartão.',
    'bindSim.tip.text2': 'Ativar o plano de dados e divertir-se!',
    'bindSim.btn.text': 'Carregar Imagem',
}
// FAQ页面
const FAQ = {
    'faq.question.1': 'Posso fazer chamadas ou enviar SMS?',
    'faq.question.2': 'Como posso comprar um plano de dados e verificar o registro do meu pedido?',
    'faq.question.3': 'Quais são as regras de pedido de dados?',
    'faq.question.4': 'Quais métodos de pagamento posso usar?',
    'faq.question.5': 'Como faço para desligar meu plano de dados caso não queira usá-lo?',
    'faq.question.6': 'Eu encomendei um plano de dados de forma bem sucedida, mas por que não posso usá-lo?',
    'faq.question.7': 'E caso eu não consiga aceder à Internet?',
    'faq.question.8': 'Quais países o plano de dados abrange?',
    'faq.question.9': 'Como posso entrar em contato com o Atendimento ao Cliente Lenovo?',
    'faq.question.10': 'Como solicito o recibo do meu pedido?',
    'faq.question.11': 'Como substituir um cartão SIM?',
    'faq.question.12': 'É grátis substituir um SIM?',
    'faq.question.13': 'Posso suspender o plano de dados ativado se meu SIM for perdido, quebrado ou estiver com defeito?',
    'faq.question.14': 'E caso eu esqueça de minha senha?',
    'faq.question.15': 'Posso fazer alterações depois que o ICCID do meu cartão SIM e o meu ID da Lenovo estiverem vinculados?',
    'faq.question.16': 'O que devo fazer se o dispositivo me pedir para inserir um código PIN, PIN 2 ou PUK, ou para inserir um APN?',
    'faq.question.17': 'Como verifico o ICCID do meu SIM?',
    'faq.question.18': 'CONTATE-NOS',
    'faq.answer.1': 'O SIM só oferece suporte a dados para acesso à rede. Você não receberá nenhum número do telemóvel. Você ainda pode realizar chamadas ou enviar SMS usando aplicativos como Skype e Whatsapp.',
    'faq.answer.2': 'Visite o site aoacwap.lenovoconnect.com para continuar.',
    'faq.answer.3': 'Os planos de dados solicitados com êxito serão ativados automaticamente (por exemplo, Expandir Meu Plano de Dados) ou irão esperar a fila para serem ativados (por exemplo, Estender Meu Plano de Dados). Não oferecemos suporte para reembolso ou suspensão do plano de dados. ',
    'faq.answer.4': 'Vendemos planos em GBP, EUR, USD, CHF, NOK, DKK, SEK e suporte para cartões de crédito/débito Visa ou Master.',
    'faq.answer.5': 'Caso queira parar de usar a conectividade do telemóvel, clique em DESLIGAR o botão "Dados móveis". Observe que seu plano de dados em andamento NÃO será suspenso ou reembolsado. ',
    'faq.answer.6.1': '1) Se o plano solicitado é para estender seu plano atual, ele só pode ser ativado depois que seu plano atual expirar. ',
    'faq.answer.6.2': '2) Se o plano solicitado é expandir seu plano atual, ele deve ser ativado automaticamente. Consulte outras perguntas frequentes sobre problemas de conectividade ou entre em contato com o Atendimento ao Cliente Lenovo.com em seu próprio país.',
    'faq.answer.6.3': '3) Se você tiver vários dispositivos com o mesmo ID Lenovo, certifique-se de que o plano de dados solicitado está sob o ICCID do SIM do dispositivo usado atualmente. ',
    'faq.answer.7.1': '1) Verifique se os "Dados móveis" estão ligados.',
    'faq.answer.7.2': '2) Verifique se o "Roaming de dados" está habilitado. Vá para Configurações -> Rede e Internet -> Rede móvel-> Roaming de dados',
    'faq.answer.7.3': '3) Verifique se o Nome do Ponto de Acesso (APN) está configurado corretamente. Vá para Configurações -> Rede e Internet -> Rede móvel -> Avançado -> Nomes dos pontos de acesso-> adicionar APN: net.truphone.com',
    'faq.answer.7.4': '4) Se esta for sua primeira conexão, pode demorar alguns minutos para que o SIM se conecte. ',
    'faq.answer.7.5': '5) Certifique-se de que o plano de dados de pré-carga esteja ativado; caso contrário, siga as instruções no pacote do SIM para ativar. ',
    'faq.answer.7.6': '6) Certifique-se de que sua localização atual está dentro do nosso âmbito de cobertura de serviço (veja a lista completa de países abrangidos abaixo) Mova seu dispositivo ao lado de uma janela ou área aberta para receber um sinal melhor. ',
    'faq.answer.8': 'O plano de dados pode abranger todos os países da UE (Áustria, Bélgica, Bulgária, Croácia, Chipre, República Tcheca, Dinamarca, Estônia, Finlândia, França, Alemanha, Gibraltar, Grécia, Hungria, Irlanda, Itália, Letônia, Lituânia, Luxemburgo, Malta, Holanda, Polônia, Portugal, Romênia, República Eslovaca, Eslovênia, Espanha, Suécia), além da Islândia, Noruega, Suíça, Reino Unido e Estados Unidos da América.',
    'faq.answer.8.1': 'O plano de dados pode abranger todos os países da UE (Áustria, Bélgica, Bulgária, Croácia, Chipre, República Tcheca, Dinamarca, Estônia, Finlândia, França, Alemanha, Gibraltar, Grécia, Hungria, Irlanda, Itália, Letônia, Lituânia, Luxemburgo, Malta, Holanda, Polônia, Portugal, Romênia, República Eslovaca, Eslovênia, Espanha, Suécia), além da Islândia, Noruega, Suíça, Reino Unido.',
    'faq.answer.9': 'Consulte as informações abaixo sobre Atendimento ao Cliente da Lenovo.com em seu próprio país.',
    'faq.answer.10': 'O recibo será enviado para o seu endereço de e-mail cadastrado automaticamente após o pedido ser realizado com êxito. Verifique sua caixa de entrada e sua caixa de correio indesejado.  Caso ainda não tenha recebido, entre em contato com o Atendimento ao Cliente Lenovo.',
    'faq.answer.11': 'Caso seu SIM esteja quebrado, perdido ou com defeito, entre em contato com o Atendimento ao Cliente Lenovo para obter uma solução.',
    'faq.answer.12': 'Sim, mas podem ser aplicadas taxas de serviço de entrega. Entre em contato com o Atendimento ao Cliente Lenovo para obter detalhes.',
    'faq.answer.13': 'Desculpe, o plano de dados não pode ser suspenso.',
    'faq.answer.14': 'Você pode redefinir sua senha em "Esqueci a senha" na página de login',
    'faq.answer.15': 'Sim. Entre em contato com o Atendimento ao Cliente Lenovo para essa solicitação. Após a verificação, a equipe de Atendimento ao Cliente ajudará a remover a vinculação atual entre o ICCID do SIM e seu ID Lenovo. Observe que os planos de dados dentro das validades não podem ser suspensos ou cancelados, independentemente do status de vinculação do ID SIM-Lenovo.',
    'faq.answer.16': 'Tente desativar e reativar o telemóvel e também reiniciar o dispositivo. Se isso não ajudar, entre em contato com nosso Serviço de Atendimento ao Cliente.',
    'faq.answer.17.1': '1) Você pode encontrar o ICCID no chip do SIM ou no suporte do SIM.',
    'faq.answer.17.2': '2) Se você ativou o SIM e o plano de dados de pré-carga, visite aoacwap.lenovoconnect.com e verifique "Eu" -> "Dispositivo"',
    'faq.answer.18': 'Consulte as informações de Atendimento ao Cliente no site da Lenovo em seu país.',
}
//平板fap
const faqApp = {
    'faq.title.1': 'FAQ-About Lenovo Connect',
    'faq.question.1': 'Q1: How do I reach Lenovo Customer Service if the following answers cannot solve my question? ',
    'faq.answer.1': 'A1: Please refer to below Customer Service information on Lenovo.com in your own country. Or directly send an email to: service@lenovoconnect.com. Please include the ICCID of the SIM in the email.',
    'faq.question.2': 'Q2: Can I make calls or send SMS?',
    'faq.answer.2': 'A2: The SIM only supports data for network. You will not receive a mobile number. It does not support voice or SMS.',
    'faq.question.3': 'Q3: Can the SIM be switched to other devices?',
    'faq.answer.3': 'A3: The SIM only can be used in the tablet. Cannot be switched to other devices.',
    'faq.question.4': 'Q4: What countries can the data plan cover? Will there be extra roaming fee?',
    'faq.answer.4': 'A4: The data plan covers all EU countries (Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden), plus Iceland, Norway, Switzerland, and United Kingdom. There is no extra roaming fee within these places.',
    'faq.title.2': 'FAQ-About Connectivity Service Package',
    'faq.question.5': 'Q1: How can I buy a service package and check my order record? Can the unused data roll into the next 30 days?',
    'faq.answer.5': 'A1: Please visit the app "Len" preloaded on the tablet. Or visit aoacwap.lenovoconnect.com to check the data usage. If the current package is not used up, it cannot be rolled into the next 30 days.',
    'faq.question.6': 'Q2: When does the gift package start to count?',
    'faq.answer.6': 'A2: The gift package starts after the register and log in to the APP "Len", and activate the preload package on the homepage.',
    'faq.question.7': 'Q3: What are the rules of ordering connectivity service package?',
    'faq.answer.7': 'A3: Service package ordered successfully will be automatically activated (e.g. Subscribe To A Monthly Connectivity Service Package) or will wait in queue to be activated after the current service was exhausted (e.g. Add An Extra Connectivity Service Package). Service package does not support refund or suspension.',
    'faq.question.8': 'Q4: What payment methods can I use?',
    'faq.answer.8': 'A4: We support Credit/Debit Visa or Master cards in GBP, EUR, USD,CHF, NOK, DKK, SEK.',
    'faq.question.9': "Q5: I have successfully ordered the service package, why can't I use it?",
    'faq.answer.9': 'A5: If it is to add an extra connectivity service package, it can only be activated once your current package expires. If it is to subscribe to a monthly connectivity service package, it should be activated automatically. Please refer to other FAQs for connectivity issue, or contact Lenovo Customer Service or email: service@lenovoconnect.com.',
    'faq.title.3': 'FAQ-About APP Len',
    'faq.question.10': 'Q1: What if I cannot find the APP or the APP was deleted by mistake?',
    'faq.answer.10': `A1: Please visit Tablet Center to re-download the APP. Or visit the link to re-download: https://aoacupg.lenovoconnect.com/common/downloadLatest`,
    'faq.question.11': "Q2: What should I do if I can't log in to the APP?",
    'faq.answer.11.1': 'A2: 1. It may take a longer time to log in to the APP for the first time. Please wait for about half a minute.',
    'faq.answer.11.2': '2. Please try to exit the APP completely and then re-enter.',
    'faq.answer.11.3': '3. If the APP registration page shows: This email has existed. Please log in directly with your previous Lenovo ID or register with a new email address.',
    'faq.answer.11.4': '4. If the APP login page shows: Card has bound by other accounts. In this case, you have already bound this card to an email account. To unbind and reset your email, please contact the customer service team or email service@lenovoconnect.com',
    'faq.question.12': 'Q3: What if I forgot my password of the registered email?',
    'faq.answer.12': 'A3: You can re-set your password via "Forgot password" on the Sign in page of the APP.',
    'faq.title.4': 'FAQ-About using data',
    'faq.question.13': "Q1: How should I turn off my connectivity package if I don't want to use it?",
    'faq.answer.13': 'A1：If you want to stop using cellular connectivity, please click OFF the "Mobile data". Please note that your ongoing package will NOT be suspended or refunded.',
    'faq.question.14': 'Q2：What if I cannot get Internet access?',
    'faq.answer.14.1': 'A2：1. Please check that "Settings--Network&Internet--Mobile data”is turned on.',
    'faq.answer.14.2': '2. Please check that "Settings--Network&Internet--Data roaming”is turned on (need to be turned on, there will be no additional roaming charges).ƒ',
    'faq.answer.14.3': '3. Check the "Settings-Network&Internet-Advanced-Access Point Names" are set correctly, it should be set to: lenovo.m2m.drei.at (Please add manually if there is not)',
    'faq.answer.14.4': '4. If this is your first time to connect, it may take a few minutes.',
    'faq.answer.14.5': '5. Please log in to the APP Len and confirm that the free data package has been activated. If it is not activated, please log in to the APP and click "Activation" on the main page.',
    'faq.answer.14.6': '6. Please confirm that your region is within the scope of service (please refer to the following countries for details). You can move to a more open place to receive the signal. (Covering all EU countries Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden, plus Iceland, Norway, Switzerland, and United Kingdom).',
    'faq.answer.14.7': '7. Please check whether the SIM card is installed correctly and restart the device.',
    'faq.answer.14.8': '8. Please check Settings-Network&Internet-Choose network, you can manually select the network among them. If "forbidden" is displayed after a network is found, please click and clear "forbidden" manually. If there is no forbidden displayed, you may change the SIM into your phone, acting the same process to see available networks.',
    'faq.question.15': "Q3: How do I check my SIM's ICCID?",
    'faq.answer.15.1': 'A3:  1. Please pull out the SIM card inserted in the tablet, the ICCID is on the card.',
    'faq.answer.15.2': '2. Please visit App Len-Me-Device',
    'faq.answer.15.3': '3. Please visit aoacwap.lenovoconnect.com and you will see your ICCID on the page.',
    'faq.question.16': 'Q4: How do I request a receipt for my order?',
    'faq.answer.16.1': 'A4: The receipt will be sent to your registered email address automatically after ordering successfully. Please do check both your inbox and junk mail box for it. If still cannot find it, please contact Lenovo Customer Service or email: service@lenovoconnect.com',
    'faq.title.5': 'FAQ-About SIM Card',
    'faq.question.17': "Q1: Can I make changes after my SIM card's ICCID and my Lenovo ID are bound?",
    'faq.answer.17': 'A1: Yes. Please contact Lenovo Customer Service or email: service@lenovoconnect.com for the unbinding request. Please note that connectivity service package within validity cannot be suspended or refunded regardless of the SIM-Lenovo ID binding status.',
    'faq.question.18': 'Q2: What should I do if the card surface is damaged or lost? Can an activated service package be suspended?',
    'faq.answer.18': 'A2: If your SIM is broken or lost or faulty, please contact Lenovo Customer Service or email: service@lenovoconnect.com. We will arrange a new delivery after the confirmation of the detailed situation. The activated package cannot be suspended or refunded.',
}
// 接口返回错误码
const iCode = {
    'iCode.i0001': 'Erro de senha',
    'iCode.i0002': 'Este e-mail já existe',
    'iCode.i0003': 'Erro de formato de senha',
    'iCode.i0004': 'A conta deve ser ativada antes do login.',
    'iCode.i0005': 'A conta está desabilitada',
    'iCode.i0006': 'Tempo limite de início de sessão',
    'iCode.i0007': 'Erro',
    'iCode.i0008': 'Erro de conta ou senha',
    'iCode.i0009': 'Insira o código de verificação gráfica de 5 dígitos',
    'iCode.i0010': 'A operação é muito frequente. Por favor, tente novamente mais tarde.',
    'iCode.i0011': 'Endereço de retorno de chamada inválido.',
    'iCode.i0012': 'Assinatura inválida.',
    'iCode.i0013': 'Atualize o código de verificação',
    'iCode.i0014': 'Erro de servidor.',
    'iCode.i0015': 'O ID de Bom Serviço bom está em branco',
    'iCode.i0016': 'Mensagem enviada com êxito',
    'iCode.i0017': 'Falha ao enviar da mensagem',
    'iCode.i0018': 'Erro do código de resgate',
    'iCode.i0019': 'Use durante o período de resgate',
    'iCode.i0020': 'O código de resgate expirou',
    'iCode.i0021': 'Código de resgate já usado',
    'iCode.i0022': 'O código de resgate perdeu a validade',
    'iCode.i0023': 'O pedido está sendo criado, aguarde...',
    'iCode.i0024': 'Falha na operação',
    'iCode.i0025': 'O cartão de número não atende às condições de troca',
    'iCode.i0026': 'Falha na geração do código QR',
    'iCode.i0027': 'Erro ao criar informações do pedido de atualização',
    'iCode.i0028': 'SIM inexistente',
    'iCode.i0029': 'Erro no número de telefone',
    'iCode.i0030': 'SMS enviado com muita frequência',
    'iCode.i0031': 'Erro de parâmetro',
    'iCode.i0032': 'O número de envio de código de verificação em um dia atingiu o limite máximo',
    'iCode.i0033': 'Inscrição realizada com êxito',
    'iCode.i0034': 'Falha no registro da conta',
    'iCode.i0035': 'Ligue o SIM ICCID primeiro',
    'iCode.i0036': 'Inicie a sessão da conta primeiro',
    'iCode.i0037': 'Falha na atualização do status',
    'iCode.i0038': 'Ativando, aguarde',
    'iCode.i0039': 'O ID do pedido está em branco',
    'iCode.i0040': 'Ativação em andamento, aguarde',
    'iCode.i0041': 'O pacote está pronto para o uso',
    'iCode.i0042': 'Falha ao ativar!',
    'iCode.i0043': 'A ativação foi bem-sucedida!',
    'iCode.i0044': 'O sistema não consegue identificar o SIM',
    'iCode.i0045': 'Pacote ativado, não repita',
    'iCode.i0046': 'Nenhum pacote ativado',
    'iCode.i0047': 'SIM descontinuado',
    'iCode.i0048': 'Informação de pacote incorreta',
    'iCode.i0049': 'Usuário ou senha em branco',
    'iCode.i0050': 'Sem pacote básico para o mês',
    'iCode.i0051': 'Sessão iniciada com êxito',
    'iCode.i0052': 'Login anormal',
    'iCode.i0053': 'Dispositivo está vazio',
    'iCode.i0054': 'Erro no código de verificação, insira novamente',
    'iCode.i0055': 'Operação bem-sucedida',
    'iCode.i0056': 'O SIM está em branco',
    'iCode.i0057': 'Falha ao obter código',
    'iCode.i0058': 'Código da empresa inexistente',
    'iCode.i0059': 'O uso do SIM é inconsistente com as propriedades da empresa',
    'iCode.i0060': 'Não opere com demasiada frequência',
    'iCode.i0061': 'Cupão de desconto recebido com sucesso',
    'iCode.i0062': 'Não atende às condições de reivindicação',
    'iCode.i0063': 'Erro ao receber cupão de desconto',
    'iCode.i0064': 'Falha na vinculação Iccid',
    'iCode.i0065': 'O cartão foi vinculado por outra conta',
    'iCode.i0066': 'Vinculação bem-sucedida',
    'iCode.i0067': 'Erro de vinculação',
    'iCode.i0068': 'O ID do SIM está em branco',
    'iCode.i0069': 'esimId está em branco',
    'iCode.i0070': 'Sem vinculação de SIM',
    'iCode.i0071': 'Usuário inexistente',
    'iCode.i0072': 'Alcunha não pode estar em branco',
    'iCode.i0073': 'Atualizado com êxito',
    'iCode.i0074': 'Falha ao atualizar',
    'iCode.i0075': 'Página inicial sem consulta de pacote do SIM anormal',
    'iCode.i0076': 'Informação relevante não disponível',
    'iCode.i0077': 'Falha ao gerar assinatura criptografada.',
    'iCode.i0078': 'Falha ao alterar',
    'iCode.i0079': 'Alteração bem-sucedida',
    'iCode.i0080': 'Não envie inscrições repetidamente!',
    'iCode.i0081': 'Atualize e teste novamente!',
    'iCode.i0082': 'Falha ao obter o gráfico do banner da página inicial',
    'iCode.i0083': 'Atualmente sem nenhum ICCID vinculado, sem pacote preferencial',
    'iCode.i0084': 'Atualmente sem nenhum ICCID vinculado, sem pacote disponível',
    'iCode.i0085': 'A autenticação foi bem-sucedida',
    'iCode.i0086': 'Falha na autenticação',
    'iCode.i0087': 'Exceção do sistema',
    'iCode.i0088': 'O cartão já possui um nome verdadeiro',
    'iCode.i0089': 'O plano foi solicitado com êxito',
    'iCode.i0090': 'Falha ao solicitar plano',
    'iCode.i0091': 'Bens de serviço inexistentes',
    'iCode.i0092': 'O pedido de serviço de atualização foi gerado',
    'iCode.i0093': 'Sem serviço de pacote de atualização',
    'iCode.i0094': 'Nenhum pedido correspondente encontrado',
    'iCode.i0095': 'O pacote atual não foi pago',
    'iCode.i0096': 'O ID do pacote está em branco no pedido',
    'iCode.i0097': 'O pacote já está habilitado',
    'iCode.i0098': 'Pedido bem-sucedido',
    'iCode.i0099': 'Nenhum número de código disponível',
    'iCode.i0100': 'Sem código de área',
    'iCode.i0104': 'Não é possível de obter sub-região do cartão SIM',
    'iCode.i0109': 'Falha ao ler o código de barras, tente novamente',
}
export default {
    ...common,
    ...language,
    ...login,
    ...register,
    ...home,
    ...me,
    ...packageCard,
    ...packageDetail,
    ...billAddress,
    ...order,
    ...device,
    ...accountInfo,
    ...myDataPlan,
    ...FAQ,
    ...iCode,
    ...payResult,
    ...Contact,
    ...bindSim,
    ...suggest,
    ...faqApp,
    'tab.text.home': 'Início',
    'tab.text.me': 'Eu'
}
